import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the landing report view for a table.
 */
export default class tableLandingReportView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function

        // Extending the summTreeColumn filter for custom summation behavior
        webix.ui.datafilter.summTreeColumn = webix.extend(
            {
                refresh: function (master, node, value) {
                    var result = 0; // Initialize result for summation
                    var resultFormat = 0; // Initialize formatted result
                    master.data.each(function (obj) {
                        if (obj.$level == 1) result += obj[value.columnId]; // Sum values at level 1
                    });
                    // Format result based on column type
                    if (value.columnId === 'CantidadTickets') {
                        resultFormat = webix.i18n.intFormat(result);
                    } else {
                        resultFormat = webix.i18n.priceFormat(result);
                    }
                    node.firstChild.innerHTML = resultFormat; // Update node with formatted result
                },
            },
            webix.ui.datafilter.summColumn, // Extend existing summColumn filter
        );

        // Return the layout configuration
        return {
            rows: [
                {
                    id: 'preloader', // Preloader ID
                    cols: [
                        {
                            view: 'datatable', // Data table view
                            id: 'treetable', // Table ID
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            scrollY: screen.width < 820 ? false : true, // Conditional vertical scrolling
                            columns: [
                                // Column definitions
                                {
                                    id: 'referentId',
                                    header: _('ID Referente'), // Localized header
                                    width: 100,
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'refinvitacionId',
                                    header: _('ID Invitacion'),
                                    width: 100,
                                    sort: 'int',
                                },
                                {
                                    id: 'referredEmail',
                                    header: _('Email'),
                                    width: 300,
                                    hidden: !devConfig.getPermAction(
                                        'sensitiveInformationEmail',
                                        'Add', // Permission check for sensitive email information
                                    ),
                                },
                                {
                                    id: 'successfullyReferred',
                                    header: _('Usuario existente'),
                                    width: 150,
                                    template: function (obj) {
                                        return obj.successfullyReferred == 1
                                            ? 'Existe' // Display if user exists
                                            : 'No existe'; // Display if user does not exist
                                    },
                                },
                                {
                                    id: 'subject',
                                    header: _('Asunto'),
                                    width: 200,
                                },
                                {
                                    id: 'message',
                                    header: _('Mensaje'),
                                    width: 400,
                                },
                                {
                                    id: 'status',
                                    header: _('Estado'),
                                    width: 150,
                                    template: function (obj) {
                                        return obj.status
                                            ? 'Enviado' // Display if sent
                                            : 'No enviado'; // Display if not sent
                                    },
                                },
                                {
                                    id: 'country',
                                    header: _('Pais'),
                                    width: 150,
                                    hidden: !devConfig.getPermAction(
                                        'sensitiveInformationCountry',
                                        'Add', // Permission check for sensitive country information
                                    ),
                                },
                                {
                                    id: 'sendDate',
                                    header: _('Fecha envío'),
                                    width: 300,
                                },
                            ],
                            autowidth: false, // Disable auto width
                            tooltip: true, // Enable tooltips
                            footer: false, // Disable footer
                            math: true, // Enable mathematical operations
                            loadahead: 0, // Load ahead configuration
                            datafetch: devConfig.getDefaultDataFetch(), // Default data fetch configuration
                            pager: 'pagerA', // Pager ID
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid component to initialize.
     */
    init(grid) {
        const _ = this.app.getService('locale')._; // Localization service
        grid = $$('treetable'); // Reference to the data table
        var url = devConfig.geturlApi() + 'es/Report/GetReferentMailHistory'; // API URL for fetching data
        var filter = ''; // Initialize filter string

        // Event listener for filtering data
        this.on(this.app, 'emailsReport:filter', (filterData) => {
            console.log(filterData); // Log filter data
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize query string

            // Construct query string based on filter data
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        console.log(date);
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to query
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to query
                    } else {
                        if (object[i][0] != 'Date') {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters to query
                        } else {
                            if (object[i][0] == 'Date') {
                                var date = object[i][1].replace(' 00:00:00', ''); // Format date
                                string1 = string1 + '&dateFrom=' + date; // Add dateFrom to query
                                string1 = string1 + '&dateTo=' + date; // Add dateTo to query
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert nested object to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Parse start date
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add dateFrom to query
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Parse end date
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add dateTo to query
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear existing grid data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load new data with filters
            filter = string1; // Update filter variable
        });

        // Event listener for sorting data
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Load sorted data
            );
        });
    }
}

// FILE DOCUMENTED
